<div class="content-container">
    <div class="title d-inline-flex w-100">
        SASS Controls Example
    </div>
    <div class="content">
        <form [formGroup]="matForm" autocomplete="off">
            <div>
                Check Boxes
            </div>
            <hr>
            <div class="row mb-3">
                <div class="col-3">
                    <mat-checkbox formControlName="checkbox">
                        <mwp-text-translate text="Standard" />
                    </mat-checkbox>
                </div>
                <div class="col-3">
                    <mat-checkbox formControlName="checkboxRequired">
                        <mwp-text-translate text="Requried" />
                    </mat-checkbox>
                </div>
                <div class="col-3">
                    <mat-checkbox formControlName="checkboxDisabled">
                        <mwp-text-translate text="Disabled" />
                    </mat-checkbox>
                </div>
                <div class="col-3">
                    <mat-checkbox formControlName="checkboxDisabledRequired">
                        <mwp-text-translate text="Disabled Requried" />
                    </mat-checkbox>
                </div>
            </div>
            <div>
                Radio Buttons
            </div>
            <hr>
            <div class="row mb-3">
                <div class="col-6">
                    <mwp-radio-button [form]="matForm" nameForControl="radio" [dataEnum]="hgsAgentType" />
                </div>
                <div class="col-6">
                    <mwp-radio-button [form]="matForm" nameForControl="radioRequired" [dataEnum]="hgsAgentType" />
                </div>
                <div class="col-6">
                    <mwp-radio-button [form]="matForm" nameForControl="radioDisabled" [dataEnum]="hgsAgentType" />
                </div>
                <div class="col-6">
                    <mwp-radio-button [form]="matForm" nameForControl="radioSelectedDisabled" [dataEnum]="hgsAgentType" />
                </div>
            </div>
            <div>
                Button Toggles
            </div>
            <hr>
            <div class="row mb-3">
                <div class="col-3">
                    <mwp-button-toggle [form]="matForm" nameForControl="buttonToggle" [dataEnum]="taxStatus" label="Standard" />
                </div>
                <div class="col-3 mb-3">
                    <mwp-button-toggle [form]="matForm" nameForControl="buttonToggleRequired" [dataEnum]="taxStatus" label="Required" />
                </div>
                <div class="col-3">
                    <mwp-button-toggle [form]="matForm" nameForControl="buttonToggleDisabled" [dataEnum]="taxStatus" label="Disabled" />
                </div>
                <div class="col-3">
                    <mwp-button-toggle [form]="matForm" nameForControl="buttonToggleSelectedDisabled" [dataEnum]="taxStatus" label="Disabled Selected" />
                </div>
            </div>
            <div>
                Slide Toggle
            </div>
            <hr>
            <div class="row mb-3">
                <div class="col-4 mb-3">
                    <mat-slide-toggle formControlName="slideToggle">
                        <span>Standard</span>
                    </mat-slide-toggle>
                </div>
                <div class="col-4 mb-3">
                    <mat-slide-toggle formControlName="slideToggleRequired">
                        <span>Required</span>
                    </mat-slide-toggle>
                </div>
                <div class="col-4 mb-3">
                    <mat-slide-toggle formControlName="slideToggleDisabled">
                        <span>Disabled</span>
                    </mat-slide-toggle>
                </div>
                <div class="col-4 mb-3">
                    <mat-slide-toggle class="Add" formControlName="slideToggleAdd">
                        <span>Standard - Add</span>
                    </mat-slide-toggle>
                </div>
                <div class="col-4 mb-3">
                    <mat-slide-toggle class="Add" formControlName="slideToggleRequiredAdd">
                        <span>Required - ADD</span>
                    </mat-slide-toggle>
                </div>
                <div class="col-4 mb-3">
                    <mat-slide-toggle class="Add" formControlName="slideToggleDisabledAdd">
                        <span>Disabled - Add</span>
                    </mat-slide-toggle>
                </div>
                <div class="col-4 mb-3">
                    <mat-slide-toggle class="Term" formControlName="slideToggleTerm">
                        <span>Standard - Term</span>
                    </mat-slide-toggle>
                </div>
                <div class="col-4 mb-3">
                    <mat-slide-toggle class="Term" formControlName="slideToggleRequiredTerm">
                        <span>Required - Term</span>
                    </mat-slide-toggle>
                </div>
                <div class="col-4 mb-3">
                    <mat-slide-toggle class="Term" formControlName="slideToggleDisabledTerm">
                        <span>Disabled - Term</span>
                    </mat-slide-toggle>
                </div>
            </div>
            
        </form>
    </div>
</div>